const validPreviewElements = [
  'bpmn:Task',
  'bpmn:UserTask',
  'bpmn:GlobalTask',
  'bpmn:CallActivity',
  'bpmn:ManualTask',
  'bpmn:ScriptTask',
  'bpmn:ServiceTask',
];

export default validPreviewElements;
